import React from 'react'
import PropTypes from 'prop-types'

import AlertDialog from '../ui-components/AlertDialog';

import FacebookConnectService from './FacebookConnectService';

import style from "./style.module"

export default class FacebookConnectButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {disabled: false}
    }

    doLogin() {
        if (!window.FB) { return }

        var self = this;
        self.setState({disabled: true});

        FB.login(function (login_response) {
            if (login_response.status === 'connected') {
                // Logged into your app and Facebook.
                // Check if we have the read email permission
                if (login_response.authResponse.grantedScopes.indexOf('email') !== -1) {
                    //console.log("Logged, redirecting...");
                    self.startOauthRequest(login_response.authResponse.accessToken);
                } else {
                    AlertDialog.show(I18n.t("pages.user_session.facebook_connect.email_required_message"));
                    self.setState({disabled: false});
                }

            } else if (login_response.status === 'not_authorized') {
                // The person is logged into Facebook, but not your app.
                AlertDialog.show(I18n.t('pages.user_session.facebook_connect.you_must_accept_the_permissions:'));
                self.setState({disabled: false});
            } else {
                // The person is not logged into Facebook, so we're not sure if
                // they are logged into this app or not.
                //console.log("Devi loggarti a facebook");
                self.setState({disabled: false});
            }
        }, {scope: "public_profile,email", return_scopes: true, auth_type: 'rerequest'});
    }

    startOauthRequest(token) {
        FacebookConnectService.startOauthRequest(token, (error, res) => {
            this.setState({disabled: false});
            if (res && !error) {
                if (this.props.onLogin) {
                    this.props.onLogin(res.body.user);
                }
            } else {
                AlertDialog.show(I18n.t('pages.user_session.facebook_connect.generic_error'));
            }
        } );
    }

    handleClick(event) {
        event.preventDefault();
        if (this.state.disabled) { return; }

        this.doLogin();
    }

    renderTitle() {
        return this.state.disabled ? I18n.t('wait') : this.props.title;
    }

    render() {
        return <div>
            <a onClick={this.handleClick.bind(this)}
               className={`btn btn-block ${style.fbButton}`}>
                <span className={style.container}>
                  <i aria-hidden={true}
                     className={style.icon + " fab fa-facebook-square"} />
                  <span>{this.renderTitle()}</span>
                </span>
            </a>
        </div>;
    }
}

FacebookConnectButton.propTypes = {
    onLogin: PropTypes.func,
    title: PropTypes.string.isRequired
};
